export const convertBytesToMb = (sizeInBytes: number) =>
  sizeInBytes / (1024 * 1024);
